import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Breakpoint, StyledAdSlotProps } from './types';

const mediaQuery = ([mqDirection, val]: Breakpoint) => css`
    @media only screen and (${mqDirection === '>'
            ? 'max'
            : 'min'}-width: ${val}px) {
        display: none;
    }
    @media only screen and (${mqDirection === '>'
            ? 'min'
            : 'max'}-width: ${val}px) {
        display: flex;
    }
`;

export const AdSlot = styled.div<StyledAdSlotProps>(
    ({ height, theme, hasMarginTop }) => css`
        margin-top: ${hasMarginTop ? theme.spacing['16px'] : 0};
        width: 100%;
        min-height: ${height || 0}px;
        overflow: hidden;
    `
);

export const AdWrapper = styled.div<StyledAdSlotProps>(
    ({ breakpoint }) => css`
        position: relative;
        justify-content: center;
        align-items: center;
        text-align: center;
        overflow: hidden;
        width: 100%;
        ${breakpoint ? mediaQuery(breakpoint) : 'display: flex;'}
    `
);

export const Placeholder = styled.div<StyledAdSlotProps>(
    ({ theme, breakpoint }) => css`
        background-color: ${theme.colors['black-opacity30']};
        border: 2px dashed
            ${breakpoint && breakpoint[0] === '>'
                ? theme.colors.crimson
                : theme.colors['tone-blue']};
        font-size: 12px;
        padding: ${theme.spacing['16px']};
        text-align: center;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    `
);

export const ReportButton = styled.button(
    ({ theme }) => css`
        margin-top: ${theme.spacing['32px']};
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        display: block;
        color: ${theme.colors['white']};
        font-weight: ${theme.type.semiBold};
        background-color: ${theme.colors['function-error']};
        text-shadow: 0px 2px 1px ${theme.colors.black};
        font-size: 20px;
    `
);
